<template>
  <div style="padding: 0px 8px;height: calc(100vh - 195px);overflow: auto">
    <div style="text-align:right;">
      <quickQuery :isDownload="false" @handleQuery="onSubmit" @quickQuery="onSubmit" :isNow="true"></quickQuery>
    </div>
    <div class="page_container" style="height:calc(100vh-135px);overflow: auto;">
      <el-table :size="size" border :data="listData" v-loading="loading">
        <!-- <el-table-column align="center" prop="" label="序号" min-width=""></el-table-column> -->
        <el-table-column align="center" prop="CarNo" :label="$t('ACSetting.车辆')" min-width="110"></el-table-column>
        <el-table-column align="center" prop="" :label="$t('ACSetting.预约类型')" min-width="90">
          <template slot-scope="scope">{{getType(scope.row)}}</template>
        </el-table-column>
        <el-table-column align="center" prop="temp" :label="$t('ACSetting.空调设置温度')+'（℃）'" min-width=""></el-table-column>
        <el-table-column align="center" prop="" :label="$t('ACSetting.空调模式')" min-width="">
          <template slot-scope="scope">{{getMode(scope.row.ACMode)}}</template>
        </el-table-column>
        <el-table-column align="center" prop="EvaporatorFan" :label="$t('ACSetting.风速挡位')" min-width=""></el-table-column>
        <el-table-column align="center" prop="" :label="$t('ACSetting.空调预约时间')" min-width="160">
          <template slot-scope="scope">{{getSetTimeString(scope.row)}}</template>
        </el-table-column>
        <el-table-column align="center" prop="duration" :label="$t('ACSetting.空调开启时长')+'(m)'" min-width=""></el-table-column>
        <el-table-column align="center" prop="setTime" :label="$t('ACSetting.创建时间')" min-width="160"></el-table-column>
        <el-table-column align="center" prop="CurrentState" :label="$t('ACSetting.状态')" min-width="80">
          <template slot-scope="scope">{{getState(scope.row)}}</template>
        </el-table-column>
        <el-table-column align="center" prop="Msg" :label="$t('ACSetting.失败原因')" min-width="160">
          <template slot-scope="scope">
            <span v-if="scope.row.CurrentState === 3">
              {{getMsg(scope.row.Msg)}}
            </span>
          </template>
        </el-table-column>
        <div slot="empty" class="empty">
          <img src="@/assets/images/pic_zanwushuju.png" style="height:calc(100vh - 375px)"/>
        </div>

      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <kl-pagination  :total="total" @current-change="pageChange" :pageSize="pageSize" :currentPage="currentPage"></kl-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from "@/views/statistics/components/generalOrQuickQuery.vue"
import { mapState } from 'vuex';
export default {
  components:{quickQuery},
  props:{
    Init:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      loading:false,
      listData:[],
      form:{
        vehicle:"",
        dateRange:[],
      },
      datePickerOptions:{
        disabledDate(date) {
          return date > new Date()
        }
      },
      currentPage:1,
      pageSize:10,
      total:0,
      vehicles:"",
    }
  },
  computed:{
    size() {
        return this.$store.getters.size
    },
    ...mapState({
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  watch:{
    Init:{
      handler(newVal){
        if(newVal){
          this.getData();
        }
      }
    },
  },
  mounted(){
  },
  methods:{
    getMsg(value){
      switch(value){
        case "401": tshi.$t("ACSetting.控制参数存在非法字段");
        case "402": tshi.$t("ACSetting.空调处于本地模式不执行远控");
        case "403": tshi.$t("ACSetting.车辆发动机未启动");
        case "404": tshi.$t("ACSetting.后舱门开启");
        case "405": tshi.$t("ACSetting.手刹松开");
        case "406": tshi.$t("ACSetting.存在刹车信号");
        case "407": tshi.$t("ACSetting.非空档位和停车档位状态");
        case "408": tshi.$t("ACSetting.存在油门信号");
        case "409": tshi.$t("ACSetting.存在四级或以上故障");
        case "410": tshi.$t("ACSetting.油量小于 10%");
        case "411": tshi.$t("ACSetting.车速大于 2km/h");
        case "412": tshi.$t("ACSetting.蓄电池电压小于 23V");
        case "413": tshi.$t("ACSetting.电车 ACC 打开，钥匙不处于 OFF 档");
        case "414": tshi.$t("ACSetting.动力电池 soC>30%");
        case "501": tshi.$t("ACSetting.控制参数存在非法字段");
        case "502": tshi.$t("ACSetting.空调处于本地模式不执行远控");
        default: return "";
      }
    },
    getState(row){
      let text;
      switch (row.CurrentState) {
        case 0:
          text = this.$t("ACSetting.未下发");
          break;
        case 1:
          text = this.$t("ACSetting.待执行");
          break;
        case 2:
          text = this.$t("ACSetting.已执行");
          break;
        case 3:
          text = this.$t("ACSetting.执行失败");
          break;
        default:
          text = this.$t("ACSetting.未知状态");
      }
      return text;
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    // 分页
    pageChange(page) {
      this.currentPage = page;
      this.getData();
    },
    getType(row){
      if(row.beginDate == row.endDate){
        return this.$t('ACSetting.单次预约');
      }else{
        return this.$t('ACSetting.周期预约');
      }
    },
    getSetTimeString(row){
      if(row.beginDate == row.endDate){
        return row.beginDate+ ' ' +row.time;
      }else{
        return row.beginDate + ' ~ ' + row.endDate + ' '+ this.$t('ACSetting.每天')+row.time;
      }
    },
    getMode(val){
      switch(val){
        case "1":
          return this.$t('ACSetting.自动');
          break;
        case "3":
          return this.$t('ACSetting.通风');
          break;
        case "4":
          return this.$t('ACSetting.制冷');
          break;
        case "5":
          return this.$t('ACSetting.制热');
          break;
        
      }
    },
    judge(){
      if(this.vehicles.indexOf(',')>-1){
        this.$message({
          message: this.$t('vehicletrack.selectmorevehicle'),
          type: "warning", 
        })
        return false;
      }
      return true;
    },
    onSubmit(val){
      console.log(val);
      // return;
      this.form.dateRange = [val.beginDate,val.endDate];
      console.log(this.form.dateRange);
      this.vehicles = this.getSelectedVehicles();
      let isOr = this.judge();
      if(!isOr) return;
      this.getData();
    },
    getData(){
      this.loading = true;
      this.$api.queryRemoteControlACRecord({
        VehicleID: this.vehicles == "" ? 0 : this.vehicles,//156918,//106309,// 156918,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        BeginDate: this.form.dateRange[0],
        EndDate: this.form.dateRange[1],
      })
      .then((res)=>{
        this.listData = res.data;
        this.total = res.recordsTotal;
        this.loading = false;
      })
      .catch((e)=>{
        this.loading = false;
        this.total = 0;
        this.listData = [];
      })
    },
  }
}
</script>
<style scoped>
.empty{
  position: relative;
}
.txt{
  position: absolute;
  bottom: 30%;
  left: 45%;
  font-size: 18px;
}
.textTitle{
  font-weight: 400;
font-size: 14px;
color: #0E193B;
}
</style>